var _circle, _circle2, _path, _circle3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGitMergeQueue = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "none"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 3.5,
  cy: 18.5,
  r: 2.645,
  stroke: "currentColor",
  strokeWidth: 1.71
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 14.5,
  cy: 13.5,
  r: 2.645,
  stroke: "currentColor",
  strokeWidth: 1.71
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M4.4 10.5a.9.9 0 1 0-1.8 0h1.8ZM3.5 16h.9v-5.5H2.6V16h.9Z"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 3.5,
  cy: 4.5,
  r: 1.5,
  fill: "currentColor"
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 8.5,
  cy: 8.5,
  r: 1.5,
  fill: "currentColor"
})));
export default SvgGitMergeQueue;